export const Domain = "pdbidrdev.com.au";
export const DefaultPdClientType = "cognito";
export const EnvironmentName = "Dev";
